import { SVGProps } from "react";

export const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      fill="#383838"
      d="M6.3451.4057v11.1999a.4078.4078 0 0 1-.1099.2812.3582.3582 0 0 1-.2654.1132c-.0995-.0015-.195-.0451-.2654-.1212a.4198.4198 0 0 1-.11-.2845v-11.2c0-.106.0396-.2071.11-.2811A.3584.3584 0 0 1 5.9698 0c.0995.0015.195.0451.2654.1212.0704.076.11.1784.11.2845Z"
    />
    <path
      fill="#383838"
      d="M11.6055 6.345h-11.2a.4196.4196 0 0 1-.2844-.11c-.076-.0703-.1196-.1658-.121-.2653a.3585.3585 0 0 1 .1132-.2654.4078.4078 0 0 1 .2812-.11h11.1999a.4198.4198 0 0 1 .2845.11c.076.0704.1196.1658.1211.2654a.3587.3587 0 0 1-.1133.2654.4078.4078 0 0 1-.2812.11Z"
    />
  </svg>
);
